import React from "react";
import { MathCell, BaseCellProps } from "@components/spreadsheet/cells";
import styles from "./TransactionSplitPercentCell.module.scss";

interface Props extends BaseCellProps<number> {
    value: number | null;
}

const formatPercent = (value: number): React.ReactNode => (
    <span className={styles.displayValue}>{value.toFixed(2)}%</span>
);

export const TransactionSplitPercentCell: React.FC<Props> = (props) => (
    <MathCell
        {...props}
        formatDisplay={formatPercent}
        inputClassName={styles.percentInput}
        wrapperClassName={styles.editWrapper}
    />
);
